const WhyToConnect = ()=>{

return (
    <div className="lg:px-32 lg:py-4 p-10 text-gray-500">
        <h2 className="font-semibold text-3xl my-6">Connect to readers & explore together</h2>
        <p>This will help you to find people of your intrest</p>
        connect with them make a community and explore 
    </div>
)
}

export default WhyToConnect